import { Component } from "@angular/core";
import { CerrixCollapsingBoxComponent } from "@app/shared/cerrix-collapsing-box/cerrix-collapsing-box.component";

@Component({
    selector: "document-templates-mail-merge-info",
    templateUrl: "./document-templates-mail-merge-info.component.html",
    styleUrls: ["./document-templates-mail-merge-info.component.scss"],
    imports: [CerrixCollapsingBoxComponent]
})
export class DocumentTemplatesMailMergeInfoComponent {}
